<template>
  <formulario-usuario />
</template>

<script>
import FormularioUsuario from "./FormularioUsuario";
export default {
  components: { FormularioUsuario },
};
</script>
